import {
  createStyles,
  Theme,
  withStyles,
  WithStyles
} from '@material-ui/core';
import Card from '@material-ui/core/Card';
import { inject, observer } from 'mobx-react';
import * as React from 'react';
import { InjectedIntlProps, injectIntl } from 'react-intl';

import { IRouteStore } from '../RouteStore';
import { IUserStore } from '../user/UserStore';

import BottomNavigation from '@material-ui/core/BottomNavigation';
import BottomNavigationAction from '@material-ui/core/BottomNavigationAction';
import CircularProgress from '@material-ui/core/CircularProgress';
import CssBaseline from '@material-ui/core/CssBaseline';
import FavoriteIcon from '@material-ui/icons/Favorite';
import LocationOnIcon from '@material-ui/icons/LocationOn';
import RestoreIcon from '@material-ui/icons/Restore';

import NavBar from '../components/navbar/NavBar';
import NotAuthorised from './NotAuthorised';

const styles = (theme: Theme) => createStyles({
  appBar: {
    position: 'relative',
  },
  bottomNav: {
    bottom: 0,
    position: 'fixed',
    width: '100%'
  },
  layout: {
    marginLeft: theme.spacing.unit * 2,
    marginRight: theme.spacing.unit * 2,
    width: 'auto',
    [theme.breakpoints.up(600 + theme.spacing.unit * 2 * 2)]: {
      marginLeft: 'auto',
      marginRight: 'auto',
      width: 600,
    },
  },
  paper: {
    marginBottom: theme.spacing.unit * 10,
    marginTop: theme.spacing.unit * 3,
    padding: theme.spacing.unit * 2,
    [theme.breakpoints.up(600 + theme.spacing.unit * 3 * 2)]: {
      marginBottom: theme.spacing.unit * 6,
      marginTop: theme.spacing.unit * 6,
      padding: theme.spacing.unit * 3,
    },
  },
});

declare type stylesKeys = 'appBar' | 'bottomNav' | 'layout' | 'paper' ;

declare interface IAppContainerProps extends InjectedIntlProps  {
  routes: IRouteStore;
  user: IUserStore;
}

export class AppContainer extends React.Component<IAppContainerProps & WithStyles<stylesKeys>, {}> {

  public componentDidMount() {
    const { formatMessage } = this.props.intl;
    document.title = formatMessage({id: 'app.title'});
  }

  public render() {
    const { classes, routes: { currentRoute }, user } = this.props;

    return <React.Fragment>
      <CssBaseline />
      {currentRoute && !user.loading
        ? <React.Fragment>
            <NavBar/>
            {user.isAuthorised
              ? <React.Fragment>
                  <main className={classes.layout}>
                    <Card className={classes.paper}>
                      {currentRoute.render()}
                    </Card>
                  </main>
                  <BottomNavigation
                    value={currentRoute.id}
                    showLabels={true}
                    className={classes.bottomNav}
                    onChange={this.handleBottomNavChange}>
                    <BottomNavigationAction label="Diary" icon={<FavoriteIcon/>} value='diary'/>
                    <BottomNavigationAction label="Settings" icon={<LocationOnIcon/>} value='settings'/>
                    <BottomNavigationAction label="Account" icon={<RestoreIcon/>} value='account'/>
                  </BottomNavigation>
                </React.Fragment>
              : <NotAuthorised/>
            }
          </React.Fragment>
        : <React.Fragment>
            <CircularProgress size={50}/>
          </React.Fragment>
      }
    </React.Fragment>
  }

  private handleBottomNavChange = (event: any, value: any) => {
    const { routes } = this.props;
    routes.navigate(value);
  }

}

export default withStyles<stylesKeys>(styles)(injectIntl<InjectedIntlProps & WithStyles<stylesKeys>>(inject('routes', 'user')(observer(AppContainer))));



// WEBPACK FOOTER //
// ./src/app/AppContainer.tsx